import React from "react";
// import moment from 'moment';
// import Loader from '../../common/components/notifications/Loader';
import UpcomingEvents from "./upcoming-events";
// import Billing from './billing';
import ViewerChart from "./ViewerChart";
import MostWatched from "./MostWatched";
import { VideoRealtimeMap } from "../../analytics/components";

const AdminView = (props) => {
  var { viewerCounts, upcomingEvents, mostWatchedEvents } = props;
  const { client } = props;
  return (
    <div>
      <ViewerChart viewerCounts={viewerCounts.data} />

      <hr style={{ borderTopColor: "lightgray" }} />

      <div className="row">
        <div className="col-md-6">
          <VideoRealtimeMap
            event={null}
            siteID={client.analyticSiteID}
            clientID={client.clientID}
            aspectFormat={true}
          />
        </div>

        <div className="col-md-6">
          <div className="panel panel-default">
            <div className="panel-heading">
              <h4>Most Watched</h4>
              <small>Most watched events this month</small>
            </div>
            <div className="panel-body">
              <MostWatched events={mostWatchedEvents.data} />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <h4>Upcoming events</h4>
            </div>
            <div className="panel-body">
              <UpcomingEvents events={upcomingEvents.data} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminView;
